// Fills the "Every chip is a chain" section from the community app's public summary.
// Shows nothing until it has a real answer, and nothing at all if there are no hand-overs yet.
(() => {
  const root = document.querySelector('[data-ss-chain]');
  if (!root || !root.dataset.api) return;

  const fmt = new Intl.NumberFormat('en-GB');
  const set = (sel, value) => {
    const el = root.querySelector(sel);
    if (el) el.textContent = fmt.format(value);
  };
  const ago = (iso) => {
    const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
    if (!Number.isFinite(days) || days < 0) return '';
    if (days < 1) return 'today';
    if (days === 1) return 'yesterday';
    if (days < 14) return `${days} days ago`;
    if (days < 60) return `${Math.round(days / 7)} weeks ago`;
    return `${Math.round(days / 30)} months ago`;
  };
  const place = (r) => {
    let country = '';
    try {
      country = r.country ? new Intl.DisplayNames(['en'], { type: 'region' }).of(r.country) : '';
    } catch (e) {
      country = r.country || '';
    }
    return [r.city, country].filter(Boolean).join(', ');
  };

  fetch(root.dataset.api, { mode: 'cors', cache: 'default' })
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      if (!d || !d.ok || !(d.chips > 0)) return;
      set('[data-ss-chips]', d.chips);
      set('[data-ss-people]', d.people);
      set('[data-ss-countries]', d.countries);
      set('[data-ss-km]', d.km);
      root.querySelector('[data-ss-stats]').hidden = false;

      const list = root.querySelector('[data-ss-recent]');
      const wrap = root.querySelector('[data-ss-recent-wrap]');
      (d.recent || []).forEach((r) => {
        const li = document.createElement('li');
        const where = document.createElement('span');
        where.textContent = `Passed on in ${place(r)}`;
        const when = document.createElement('time');
        when.textContent = ago(r.date);
        when.dateTime = r.date;
        li.append(where, when);
        list.append(li);
      });
      wrap.hidden = list.children.length === 0;
    })
    .catch(() => {});
})();
